<template>
  <div
    v-if="productStore.productDetails.isSubscription"
  >
    <div class="product-details__container">
      <header
        class="product-details__headline product-details__headline--product-subscription"
        :title="$t('ads.main.head.subscription.title')"
        v-html="$t('ads.main.head.generic_subscription')"
      />
    </div>
    <div class="product-details__container">
      <div class="product-content-block product-content-block--text-block-left">
        <div class="product-content-block__wrapper">
          <div class="product-content-block__wrapper-text">
            <div class="product-content-block__wrapper-text-inner">
              <h2
                class="product-content-block__headline headline headline--type_h2"
                v-html="$t('ads.subscription.headline')"
              />
              <div
                class="product-content-block__description"
                v-html="$t('ads.subscription.text')"
              />
              <div class="product-content-block__button">
                <div class="product-content-block__button-inner">
                  <a
                    class="button button--text button--link-arrow product-content-block__button-link"
                    :href="$t('ads.subscription.link.href')"
                    v-html="$t('ads.subscription.link.text')"
                  />
                </div>
              </div>
            </div>
          </div>
          <lazy-load class="product-content-block__wrapper-image">
            <div class="product-content-block__images">
              <image-element
                :src="[fallbackImage]"
                :alt="$t('ads.main.head.generic_subscription')"
                img-class="product-content-block__image product-content-block__image--auto-center"
              />
            </div>
          </lazy-load>
        </div>
      </div>
    </div>
    <div
      v-if="productSubscription.displayName && productSubscription.shortDescription"
    >
      <div class="product-details__container product-details__subs-part">
        <header class="product-details__headline product-details__headline--product-subscription">
          {{ $t('ads.main.head.subscription', [productStore.productDetails.product.description1, productStore.productDetails.product.description3 ]) }}
        </header>
      </div>
      <div class="product-details__container">
        <product-content-block
          :show-carousel="showCarousel"
          :fallback-image="fallbackImage"
          class="product-subscription"
          read-more-target-class="product-details__headline--product-subscription"
          :headline="productSubscription.displayName"
          :subline="productSubscription.subtitle"
          :text="productSubscription.shortDescription"
          :link1-text="productSubscription.linkText"
          :link1-url="productSubscription.linkUrl"
          :images="productSubscription.images"
          type="subscription"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import {Options, Prop} from 'vue-property-decorator';
  import ProductContentBlock from '../../components/productContentBlock/productContentBlock.vue';
  import productStore from '../../stores/product/ProductStore';
  import type ProductContent from '../../types/ProductContent';
  import {ProductDetailsSectionMixin, ProductDetailsSectionClass} from '../../utilities/vueMixins/productDetailsSectionMixin/productDetailsSectionMixin';

  @Options({
    name: 'product-subscription',
    components: {
      ProductContentBlock
    },
    mixins: [ProductDetailsSectionMixin]
  })
  export default class ProductSubscription extends ProductDetailsSectionClass {
    @Prop({default: false})
    showCarousel: boolean;

    @Prop()
    fallbackImage: string;

    productStore = productStore;

    get productSubscription(): ProductContent {
      this.hideContainer(!this.productStore.productDetails.isSubscription);
      return this.productStore.productSubscription;
    }
  }
</script>
